<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="update">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="isItemFound()">
              <input-text v-model="iban_name" :options="{ id: 'iban_name', transPrefix: `${transPrefix}.fields`, label: 'iban_name', error: fieldErrors.name }"/>
              <input-text v-model="iban_number" :options="{ id: 'iban_number', transPrefix: `${transPrefix}.fields`, label: 'iban_number', error: fieldErrors.iban }"/>
              <select-banks v-model="iban_bank_id" :options="{ id: 'iban_bank_id', transPrefix: `${transPrefix}.fields`, label: 'iban_bank', error: fieldErrors.bankId }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${ibansRoutePrefix}.show`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button v-if="isItemFound()" type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { IBANS_SHOW as CRUD_ACTION_SHOW,IBANS_UPDATE as CRUD_ACTION_UPDATE } from 'actions/ibans';
  const CRUD_CODE="captains";
  const IBANS_CODE="ibans";
  export default {
    name: "IbanEdit",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        ibansRoutePrefix: `${CRUD_CODE}.${IBANS_CODE}`,
        ibansTransPrefix: `${CRUD_CODE}.${IBANS_CODE}`,
        id:this.$router.currentRoute.params.id,
        iban_id: this.$router.currentRoute.params.iban_id,
        country_id: '',
        iban_bank_id:'',
        iban_name:'',
        iban_number:'',
        connected: false,
        ready_to_work: false,
        suspended: false,
        email: '',
        mobile_number: '',
        name:'',
        serverError: '',
        fieldErrors: {},
        responseStatus:'',
        formMode: 'edit',
        loading: false,
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      isItemFound(){
        return this.responseStatus!==404;
      },
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.iban_id=response.data.id;
          this.iban_number=response.data.iban;
          this.iban_name=response.data.name;
          this.iban_bank_id=response.data.bank?response.data.bank.id:null;
        }).catch(error => {
          this.loading = false;
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
      prepareRequestData(){
        return {
          name: this.sanitizeField("iban_name"),
          iban: this.sanitizeField("iban_number"),
          bankId: this.sanitizeField("iban_bank_id"),
          storeUrl: this.sanitizeField("store_url"),
        }
      },
      update() {
        this.loading = true;
        this.$store.dispatch(CRUD_ACTION_UPDATE, {
          id: this.iban_id,
          data: {
            ...this.prepareRequestData()
          },
        })
        .then(() => {
          this.loading = false;
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.update_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.ibansRoutePrefix}.show` })
        })
        .catch(error => {
          this.loading = false;
          this.fieldErrors={};
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        })
      }
    },
  };
</script>
